import { render, staticRenderFns } from "./template.pug?vue&type=template&id=4a87ce50&scoped=true&lang=pug&"
import script from "./CreatePayoutRequestModal.vue?vue&type=script&lang=js&"
export * from "./CreatePayoutRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=4a87ce50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87ce50",
  null
  
)

export default component.exports